<template>
	<b-modal id="modal-settings" title="About UnderlineMe">
		<header id="modal-settings___BV_modal_header_" class="modal-header">
			<h5 id="modal-settings___BV_modal_title_" class="modal-title">
				{{ user.name }}'s
			</h5>
			<span class="close" @click="$bvModal.hide('modal-about')">
				<x-icon size="1.25x"></x-icon>
			</span>
			<button type="button" aria-label="Close" class="close">×</button>
		</header>
		<div class="settings-area">
			<h3>Settings v{{ version }}</h3>
		</div>
	</b-modal>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons';
export default {
	components: {
		XIcon,
		CheckIcon,
	},

	data: function () {
		var obj = {
			lock: false,
			bucket: {
				title: '',
				color: 2,
			},
		};
		return obj;
	},

	computed: {
		user: function () {
			return this.$store.getters['user/user'];
		},
		version: function () {
			return this.$store.getters['version'];
		},
	},

	methods: {},

	mounted: function () {},
};
</script>

<style lang="scss">
#modal-settings___BV_modal_outer_ {
	color: var(--font-color);
	.modal-dialog {
		max-width: 800px;
		margin: var(--spacer);
	}
	.modal-content {
		.close {
			top: 26px;
			right: 30px;
		}
		> .modal-header {
			display: none;
		}
	}
	.modal-body {
		padding: 0;
	}
	.settings-area {
		padding: var(--spacer-sm);
	}
}
</style>
